import Reveal from "../Plan2Benefit/Reveal.jsx";
import SectionHeading from "../Plan2Benefit/SectionHeading.jsx";
import CountUp from "../Plan2Benefit/CountUp.jsx";
import WithStar from "./WithStar.jsx";
import { proofStats } from "./data.js";

/* ─────────────────────────────────────────────────────────────
   Traction ("Proof") — the numbers so far, read the way a car's
   own spec sheet reads: plain labels, bold tabular figures. Kept
   as its own section (rather than folded into Hero) so it can
   carry real, growing numbers independent of the pitch above it.

   Sits on a faint indigo-tinted "raised" wash (rather than flat
   white like the sections around it) so the numbers read as a
   distinct beat in the page's rhythm — matching alternation used
   in the reference design.
───────────────────────────────────────────────────────────── */
export default function Traction() {
  return (
    <section
      id="proof"
      className="border-y border-[#eceafb] bg-gradient-to-b from-[#4328E7]/[0.035] via-[#4328E7]/[0.05] to-white px-4 py-16 sm:px-6 lg:px-8 lg:py-24"
    >
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <SectionHeading eyebrow="Proof" title="The numbers so far" />
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-[20px] border border-[#eceafb] bg-[#eceafb] sm:grid-cols-2 lg:grid-cols-4">
            {proofStats.map((stat) => (
              <div
                key={stat.label}
                className="group relative overflow-hidden bg-white px-6 py-7 transition-colors duration-300 hover:bg-[#faf9ff]"
              >
                <p className="bg-gradient-to-br from-[#4328E7] to-[#6d63ff] bg-clip-text font-montserrat text-[1.85rem] font-semibold tabular-nums tracking-[-0.01em] text-transparent sm:text-[2rem]">
                  <CountUp to={stat.to} prefix={stat.prefix} suffix={stat.suffix} />
                </p>
                <p className="mt-2 font-montserrat text-[13.5px] font-semibold text-[#0d0828]/55">
                  <WithStar text={stat.label} />
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
